import OSS from 'ali-oss'
import { batchGetOssResource } from '@/api/common'
import { generateUUID } from '@/utils/index'

/**
 * 用于上传通用资源，对于资源存放目录有严格分类，根据resourceType分类
 */

/**
 * 获取阿里云client配置
 * @param config 阿里云配置
 * @param timeout  超时时间, 默认为 60000
 * @returns {Promise<Client>}
 */
const getOssClient = async function (config, timeout = 60000) {
  const ossConfig = {
    accessKeyId: config.accessKeyId,
    accessKeySecret: config.accessKeySecret,
    bucket: config.bucketName,
    endpoint: 'oss-cn-shenzhen.aliyuncs.com',
    stsToken: config.securityToken,
    region: 'oss-cn-shenzhen',
    timeout: timeout
  }
  console.log('ossConfig', ossConfig)
  return new OSS(ossConfig)
}

/**
 * 完整上传
 * @param bufferArr  文件
 * @param timeout 超时时间, 默认为 60000
 * @param config 阿里云配置
 * @returns {Promise<*>}
 */
const uploadFile = async function (bufferArr, config, timeout = 60000) {
  console.log('config', config)
  try {
    const client = await getOssClient(config, timeout)
    const result = await client.put(config.objectKey, bufferArr)
    const head = await client.head(config.objectKey)
    result.head = head.res.headers
    return result
  } catch (e) {
    console.error('完整上传文件失败', e)
    throw e
  }
}

/**
 *
 * @param resourceType 资源类型
 * @param file 文件，支持blob Buffer file
 * @param ext 文件后缀名
 * @param timeout 超时时长
 * @return {Promise<*>}
 */
export const generalUploadFile = async function ({ resourceType, file, ext, timeout = 60000 }) {
  const res = await batchGetOssResource({ resourceType })
  const { state, data } = res
  if (state !== 11) return
  const objectKey = `${data.objectDir}${generateUUID(32)}.${ext}`
  const config = {
    ...data.credentials,
    bucketName: data.bucketName,
    objectKey
  }
  return await uploadFile(file, config, timeout)
}

export default {
  getOssClient,
  uploadFile,
  generalUploadFile
}
